<template>
  <sh-access-bar slot="access" :label="titleAndVersion" style="">
    <!-- <sh-tabs v-if="displayAreaName" slot="tabs">
      
      <sh-tab-item
        v-for="item in activeRegions"
        icon="location-pin"
        :label="item.regionName"
        :active="item.active"
        :key="item.regionName"
        fixed
        sticky
        no-arrows
      ></sh-tab-item>
    </sh-tabs> -->

    <!-- <div v-if="userInGroup" slot="tabs" style="display: flex"></div> -->

    <div v-if="userInGroup" slot="tabs" style="display: flex">
      <div
        v-for="item in activeRegions"
        :key="item.regionName"
        style="margin: auto; padding-right: 5px"
      >
        <sh-icon icon="location-pin" color="#EC6602"></sh-icon>
        <div style="vertical-align: middle">
          <sh-text style="text-align: center" size="title-1">{{
            item.regionName
          }}</sh-text>
        </div>
      </div>
    </div>

    <div
      v-if="buildDestination === 'development'"
      slot="tabs"
      style="
        margin-left: 25%;
        margin-top: 16px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
      "
    >
      <sh-icon icon="warning"></sh-icon>
      <div style="vertical-align: middle">
        <sh-text size="title-1">For development use only</sh-text>
      </div>
    </div>
    <div slot="functions" style="display: flex">
      <div style="margin-top: 16px; margin-bottom: 16px"></div>

      <sh-user-identifier
        slot="user"
        :name="userName"
        info="Siemens Healthineers"
        id="target-1"
      >
      </sh-user-identifier>
      <sh-popover target="target-1" position="bottom-left">
        <div
          v-if="userInGroup"
          class="popover-menu-item"
          @click="openManageModal"
        >
          <sh-icon icon="manage-message-templates" button></sh-icon>
          <sh-text style="text-align: center">Manage Subscriptions</sh-text>
        </div>
        <div
          v-if="userInGroup"
          class="popover-menu-item"
          @click="openIssueModal"
        >
          <sh-icon icon="feedback-add" button></sh-icon>
          <sh-text style="text-align: center">Report Issue</sh-text>
        </div>
        <div
          v-if="userInGroup"
          class="popover-menu-item"
          @click="openFeedbackModal"
        >
          <sh-icon icon="send-rating-feedback" button></sh-icon>
          <sh-text style="text-align: center">Provide Feedback</sh-text>
        </div>
        <div
          v-if="userInGroup"
          class="popover-menu-item"
          @click="openUserManualModal"
        >
          <sh-icon icon="pdf" button></sh-icon>
          <sh-text style="text-align: center">User Manual</sh-text>
        </div>

        <div
          v-if="userInGroup"
          class="popover-menu-item"
          @click="openChangeLog"
        >
          <sh-icon
            icon="information"
            color="var(--text-primary)"
            button
          ></sh-icon>
          <sh-text style="text-align: center">Latest Features</sh-text>
        </div>

        <div class="popover-menu-item" @click="signOutOidc">
          <sh-icon icon="logoff" button></sh-icon>
          <sh-text style="text-align: center">Sign Out</sh-text>
        </div>
      </sh-popover>
    </div>
  </sh-access-bar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  props: [],
  name: "AccessBar",
  data() {
    return {};
  },
  mounted() {},
  created() {},
  computed: {
    ...mapGetters([
      "appTitle",
      "appVersion",
      "buildMode",
      "buildDestination",
      "regions",
    ]),
    ...mapGetters("oidcStore", ["oidcUser", "userInGroup"]),
    userName: function () {
      return this.oidcUser ? this.oidcUser.email : "";
    },
    displayAreaName: function () {
      if (this.$route.name === "CountyMap") return false;
      else return true;
    },

    titleAndVersion: function () {
      return this.appTitle + " " + this.appVersion;
    },

    activeRegions: function () {
      return this.regions.filter((el) => {
        return el.active === true;
      });
    },
  },
  methods: {
    ...mapActions(["getEmailSubscriptionOptions"]),
    ...mapActions("oidcStore", ["signOutOidc"]),

    openFeedbackModal() {
      document.querySelector("#feedback-modal").visible = true;
    },

    openIssueModal() {
      document.querySelector("#issue-modal").visible = true;
    },

    async openManageModal() {
      await this.getEmailSubscriptionOptions();
      document.querySelector("#manage-modal").visible = true;
    },

    openUserManualModal() {
      window.open("/usermanual.pdf");
    },

    openChangeLog() {
      document.querySelector("#change-modal").visible = true;
    },

    exportUserManual() {
      console.log("open");
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.popover-menu-item {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  align-items: center;
}
</style>
